import { render, staticRenderFns } from "./order-attendance-fab.vue?vue&type=template&id=9f410530&scoped=true"
import script from "./order-attendance-fab.vue?vue&type=script&lang=js"
export * from "./order-attendance-fab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f410530",
  null
  
)

export default component.exports